import { SET_EMOTION_ATTENUATION } from "./types";

const setEmotionAttenuation = (emotion, hours) => async (dispatch) => {
    dispatch({
        type: SET_EMOTION_ATTENUATION,
        emotion,
        hours,
    });
};

export default setEmotionAttenuation;
